<template>
  <div class="row">
    <div class="col notification" :class="{ 'notification--showing': show }">
      <p class="notification__wrapper">
        <span class="notification__message">{{ message }}</span>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'Notification',
  props: ['message', 'show'],
});
</script>
